import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy thank-you URL. Purchases now land on a per-plan URL
 * (`/subscription/success-quarterly`, `-annual`, `-trial`, ...) so ad platforms
 * can key conversions off the URL. Kept as a redirect for old links.
 */
export const Route = createFileRoute("/subscription/success/")({
  beforeLoad: () => {
    throw redirect({ to: "/subscription/success-quarterly", replace: true });
  },
});
